import { Carousel, Heading, P } from '@pcln/horizon'
import { useEffect } from 'react'

import { fireSimilarHotelsClickEvent, fireSimilarHotelsLoadEvent } from '@/components/TripActivity/ga4'
import type { HotelDealMatch } from '@/components/TripActivity/types'

import { SimilarHotelMediaSnippet } from './SimilarHotelMediaSnippet'
import { tripActivityVariants } from './TripActivity.variant'

type SimilarHotelsProps = {
  similarHotels: HotelDealMatch[]
  isLoading: boolean
  pageName: 'homepage' | 'landing'
  useSmallerHeading?: boolean
  abandonedHotelName?: string
}

export default function SimilarHotels({
  similarHotels,
  isLoading,
  pageName,
  useSmallerHeading,
  abandonedHotelName,
}: Readonly<SimilarHotelsProps>) {
  const { similarHotelsHeading } = tripActivityVariants({ useSmallerHeading })
  useEffect(() => {
    if (!isLoading && similarHotels.length > 0) {
      fireSimilarHotelsLoadEvent({ displayedHotels: similarHotels, pageName })
    }
  }, [isLoading, similarHotels, pageName])

  if (isLoading || similarHotels.length === 0) {
    return null
  }
  return (
    <div className='flex flex-col gap-3'>
      <div className='flex flex-col gap-1'>
        <Heading as='h3' className={similarHotelsHeading()}>
          You may also like
        </Heading>
        {abandonedHotelName && (
          <P textStyle='subheading4' className='md:text-body2'>{`Similar hotels to ${abandonedHotelName}`}</P>
        )}
      </div>
      <Carousel
        ariaLabel='Similar hotels'
        dragFree
        align='start'
        slideWidth='auto'
        pagination='numbers'
        type='content'
        slides={similarHotels.map((card, cardIndex) => ({
          id: card.hotelId,
          childrenNodes: (
            <SimilarHotelMediaSnippet
              key={card.hotelId}
              hotel={card}
              onClick={() => fireSimilarHotelsClickEvent({ hotel: card, index: cardIndex + 1, pageName })}
            />
          ),
        }))}
      />
    </div>
  )
}
